import api from '../_api'
import {
    FETCH_DATATRANSFERS_REQUEST,
    FETCH_DATATRANSFERS_SUCCESS,
    FETCH_DATATRANSFERS_FAILED,
    FETCH_DATATRANSFERS_RESOURCEID_REQUEST,
    FETCH_DATATRANSFERS_RESOURCEID_SUCCESS,
    FETCH_DATATRANSFERS_RESOURCEID_FAILED
} from './mutation-type'

const getDataTransfers = async ({ commit, state, getters, rootGetters }, { projectIdx, month }) => {
    commit(FETCH_DATATRANSFERS_REQUEST)
    try {
        const { status, data } = await api.fetchDataTransfers({ projectIdx, month }, rootGetters.requiredService)
        commit(FETCH_DATATRANSFERS_SUCCESS, { status, data: data.data })
        return data
    } catch (error) {
        commit(FETCH_DATATRANSFERS_FAILED, error)
        throw error
    }
}

const getDataTransfersResourceId = async ({ commit, state, getters, rootGetters }, { projectIdx, month, resourceId, index }) => {
    commit(FETCH_DATATRANSFERS_RESOURCEID_REQUEST)
    try {
        const { status, data } = await api.fetchDataTransfersResourceId({ projectIdx, month, resourceId }, rootGetters.requiredService)
        commit(FETCH_DATATRANSFERS_RESOURCEID_SUCCESS, { status, data: data.data, index })
        return data
    } catch (error) {
        commit(FETCH_DATATRANSFERS_RESOURCEID_FAILED, error)
        throw error
    }
}

export default {
    getDataTransfers,
    getDataTransfersResourceId
}
